import {AchievementPopupService} from "app/game/achievements/service/AchievementPopupService";
import {AchievementService} from "./service/AchievementService";
import {achievementDialog, AchievementDialog} from "./dialog/AchievementDialogComponent";
import {AchievementDialogService} from "./service/AchievementDialogService";
import {routerConfig} from "./RouterConfig";

export default function() {
    return angular.module("tfApp.game.achievements", [])
                  .service(AchievementPopupService.id, AchievementPopupService)
                  .service(AchievementService.id, AchievementService)
                  .service(AchievementDialogService.id, AchievementDialogService)
                  .component(AchievementDialog, achievementDialog())
                  .run(achievementServiceInit)
                  .config(routerConfig)
                  .name;
}

/** @ngInject */
export function achievementServiceInit(achievementPopupService: AchievementPopupService) {
    achievementPopupService.start();
}
